// Shared status colour system — one source of truth for every page.
export const STATUS_TONES = {
  // Visits
  scheduled: "bg-slateblue-light text-slateblue border border-slateblue/30",
  in_progress: "bg-gold-light text-gold-dark border border-gold/40",
  completed: "bg-sage-light text-sage-dark border border-sage/40",
  missed: "bg-coral-light text-coral-dark border border-coral/40",
  cancelled: "bg-slate-100 text-slate-400 border border-slate-200 line-through",
  // Clients / generic
  active: "bg-sage-light text-sage-dark border border-sage/40",
  inactive: "bg-slate-100 text-slate-500 border border-slate-200",
  // Invoices
  draft: "bg-slate-100 text-slate-500 border border-slate-200",
  sent: "bg-slateblue-light text-slateblue border border-slateblue/30",
  paid: "bg-sage-light text-sage-dark border border-sage/40",
  // Incidents
  open: "bg-coral-light text-coral-dark border border-coral/40",
  under_review: "bg-gold-light text-gold-dark border border-gold/40",
  closed: "bg-sage-light text-sage-dark border border-sage/40",
  // Severity
  low: "bg-sage-light text-sage-dark border border-sage/40",
  medium: "bg-gold-light text-gold-dark border border-gold/40",
  high: "bg-coral-light text-coral-dark border border-coral/40",
  // Compliance
  valid: "bg-sage-light text-sage-dark border border-sage/40",
  registered: "bg-sage-light text-sage-dark border border-sage/40",
  received: "bg-sage-light text-sage-dark border border-sage/40",
  expiring: "bg-gold-light text-gold-dark border border-gold/40",
  pending: "bg-gold-light text-gold-dark border border-gold/40",
  missing: "bg-coral-light text-coral-dark border border-coral/40",
  not_registered: "bg-coral-light text-coral-dark border border-coral/40",
  expired: "bg-coral-light text-coral-dark border border-coral/40",
  lapsed: "bg-coral-light text-coral-dark border border-coral/40",
  not_requested: "bg-coral-light text-coral-dark border border-coral/40",
  "n/a": "bg-slate-100 text-slate-500 border border-slate-200",
};

export const statusTone = (s) =>
  STATUS_TONES[s] || "bg-slate-100 text-slate-500 border border-slate-200";

// Per-client colour tags for at-a-glance identification across rotas.
export const CLIENT_TAGS = {
  rose: { label: "Rose", dot: "bg-rose-500", bar: "border-l-rose-500" },
  amber: { label: "Amber", dot: "bg-amber-500", bar: "border-l-amber-500" },
  emerald: { label: "Emerald", dot: "bg-emerald-500", bar: "border-l-emerald-500" },
  sky: { label: "Sky", dot: "bg-sky-500", bar: "border-l-sky-500" },
  violet: { label: "Violet", dot: "bg-violet-500", bar: "border-l-violet-500" },
  teal: { label: "Teal", dot: "bg-teal-500", bar: "border-l-teal-500" },
  orange: { label: "Orange", dot: "bg-orange-500", bar: "border-l-orange-500" },
  slate: { label: "Slate", dot: "bg-slate-400", bar: "border-l-slate-400" },
};
export const clientTag = (key) => CLIENT_TAGS[key] || null;

export function StatusPill({ status, className = "" }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold capitalize ${statusTone(status)} ${className}`}
    >
      {String(status).replace(/_/g, " ")}
    </span>
  );
}

// Consistent branded accent bar shown under every page heading.
export function HeaderAccent({ className = "" }) {
  return (
    <div className={`mt-3 h-1.5 w-24 rounded-full bg-gradient-to-r from-brand via-mint to-gold ${className}`} />
  );
}
